import { Address } from './address';

export class ServiceAddress extends Address {
  public Order?: number;
  public PremiseId?: string;
  public SaId?: string;
  public SaStatusFlag?: string;
  public SaStartDate?: string;
  public SaEndDate?: string;
  public IsResidential?: boolean;
  public SaTypeCode?: string;
  public FullAddress?: string;
  public SaRateScheduleCode?: string;
  public SARenewalIndicator?: string;
  public BillingRateExpirationDate?: string;
  public BillingRate?: string;
  public BillingRateValue?: any;
  public BillingRateDescription?: string;
  public SuppressBillingRateIndicator?: string;
  public ServiceNickName?: string;
  public SaBalance?: string;
  public SaStatusDescription?: string;
}
